// @ts-check

import "./jsdoc-types"
import { ImageTeaser } from "./contentful/ImageTeaser";
import { NewsletterSubscriptionForm } from "./contentful/NewsletterSubscriptionForm";
import { NewsletterUnsubscribeForm } from "./contentful/NewsletterUnsubscribeForm";
import { RichText } from "./contentful/RichText";
import { Robert } from "./contentful/Robert";
import { Container } from "./contentful/Container";
import { GridContainer } from "./contentful/GridContainer";
import { ContactForm } from "./contentful/contactform/ContactForm";
import { ContactFormProvider } from "./contentful/contactform/ContactFormContext";
import { CatalogOrderForm } from "./contentful/CatalogOrderForm";
import { FeedbackAppForm } from "./contentful/FeedbackAppForm";

/**
 * @param {Object} props
 * @param {PageEntry["fields"]["content"]} props.cdaEntries
 * @param {PageEntry} [props.pageCdaEntry]
 */
export function PageComponentsRenderer({ cdaEntries, pageCdaEntry }) {
	/**
	* @param {PageEntry["fields"]["content"][number]} cdaEntry
	*/
	const getModelComponent = (cdaEntry) => {
		switch (cdaEntry.sys.contentType.sys.id) {
			case "richText":
				return <RichText key={ cdaEntry.sys.id } cdaEntry={/** @type {RichTextEntry} */ (cdaEntry) } />;
			case "imageTeaser":
				return <ImageTeaser key={ cdaEntry.sys.id } cdaEntry={/** @type {ImageTeaserEntry} */ (cdaEntry) } />;
			case "robert":
				return pageCdaEntry && <Robert key={ cdaEntry.sys.id } pageCdaEntry={ pageCdaEntry } />
			case "newsletterSubscriptionForm":
				return <NewsletterSubscriptionForm key={ cdaEntry.sys.id } cdaEntry={ cdaEntry } />
			case "newsletterUnsubscribeForm":
				return <NewsletterUnsubscribeForm key={ cdaEntry.sys.id } cdaEntry={ cdaEntry } />
			case "container":
				return <Container key={ cdaEntry.sys.id } cdaEntry={/** @type {ContainerEntry} */ (cdaEntry) } pageCdaEntry={ pageCdaEntry } />
			case "gridContainer":
				return <GridContainer key={ cdaEntry.sys.id } cdaEntry={/** @type {GridContainerEntry} */ (cdaEntry) } />
			case "contactForm":
				return (
					<ContactFormProvider>
						<ContactForm key={ cdaEntry.sys.id } cdaEntry={/** @type {ContactFormEntry} */ (cdaEntry) } />
					</ContactFormProvider>
				)
            case "catalogOrderForm":
                return <CatalogOrderForm key={ cdaEntry.sys.id } cdaEntry={/** @type {ContactFormEntry} */ (cdaEntry) } />
			case "feedbackAppForm":
				return <FeedbackAppForm key={ cdaEntry.sys.id } cdaEntry={/** @type {FeedbackAppFormEntry} */ (cdaEntry) } />
			default:
				console.warn(`[Service Page Content][ComponentRenderer] Unknown content type (${cdaEntry.sys.contentType.sys.id}, entry ID: ${cdaEntry.sys.id})`)
				return null;
		}
	}

	return cdaEntries?.map((cdaEntry) => (
		<div key={ cdaEntry.sys.id } className="content-platform__service-page__content">
			{ getModelComponent(cdaEntry) }
		</div>
	))
}
